import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'
import ResponsiveModal, {
  ResponsiveModalBody,
  ModalSizes,
} from '@src/components/ResponsiveModal/ResponsiveModal'
import messages from '@utils/messages'
import { Link } from '@src/components/Link'
import { support } from '@src/routes'
import { makeStyles } from '@material-ui/core/styles'
import { sendEvent } from '@src/utils/analytics/coreAnalytics'
import { GTMEventTypes } from '@sial/common-utils'

const useStyles = makeStyles((theme) => ({
  definitionList: {
    margin: 0,
    padding: 0,
    marginBottom: theme.spacing(4),
    '& > *': { display: 'flex', flexWrap: 'wrap' },
    '& > * + *': { marginTop: theme.spacing(2) },
    '& dt, & dd': { margin: 0, padding: 0, flexGrow: 1, display: 'contents' },
    '& dt': { fontWeight: theme.typography.fontWeightMedium },
  },
}))

interface StatusModalProps {
  open: boolean
  onClose: () => void
  onCustomerSupportLinkClick?: () => void
  statusMap: [React.ReactNode, React.ReactNode][]
  statusHeader: React.ReactNode
  orderStatus?: string | undefined
  orderNumber?: string
}

const StatusModal: React.FC<StatusModalProps> = ({
  open,
  onClose,
  onCustomerSupportLinkClick,
  statusMap,
  statusHeader,
  orderStatus,
  orderNumber,
}) => {
  const classes = useStyles()
  const linkId = 'order_status_customer_service_link'

  return (
    <ResponsiveModal
      open={open}
      onClose={onClose}
      size={ModalSizes.Small}
      renderTitle={() => <Typography variant="h2">{statusHeader}</Typography>}
    >
      <ResponsiveModalBody>
        <dl className={classes.definitionList}>
          {statusMap.map(([term, definition], i) => (
            <div key={i}>
              <dt>{term}:&nbsp;</dt>
              <dd>{definition}</dd>
            </div>
          ))}
        </dl>
        <Typography variant="body2">
          <FormattedMessage
            {...messages.ORDER_STATUS_INFO}
            values={{
              customerService: (
                <Link href={support.customerSupport()}>
                  <a
                    data-testid={linkId}
                    id={linkId}
                    tabIndex={0}
                    role="link"
                    onKeyPress={() => {
                      if (onCustomerSupportLinkClick)
                        onCustomerSupportLinkClick()
                    }}
                    onClick={() => {
                      sendEvent({
                        eventType: GTMEventTypes.AnalyticsEvent,
                        payload: {
                          event: 'order_interaction',
                          action: 'contact customer service',
                          detail: orderNumber ? orderNumber : orderStatus,
                          section: 'order status',
                          order_type: undefined,
                          component: 'StatusModal',
                          element_type: 'link',
                          element_text: 'customer service',
                          link_url: support.customerSupport(),
                          core_event: 'no',
                          user_detail: undefined,
                          event_group: undefined,
                          event_subgroup: undefined,
                        },
                      })

                      if (onCustomerSupportLinkClick)
                        onCustomerSupportLinkClick()
                    }}
                  >
                    <FormattedMessage
                      id="CUSTOMER_SERVICE"
                      defaultMessage="Customer Service"
                    />
                  </a>
                </Link>
              ),
            }}
          />
        </Typography>
      </ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default StatusModal
